export enum NeighborhoodInsightChipType {
  DEALS_VOLUME = 'DEALS_VOLUME',
  POPULAR_ROOM = 'POPULAR_ROOM',
  PRICE_PER_METER = 'PRICE_PER_METER',
  PRICE_TREND_COMPARED_TO_CITY = 'PRICE_TREND_COMPARED_TO_CITY',
}

export interface NeighborhoodInsightChipConfig {
  type: NeighborhoodInsightChipType;
  text: string;
}
